import { createReducer } from '@reduxjs/toolkit';

import { SmartReplyResponsePayloadV2 } from '../components/SmartConversationReplyButton/useSmartReplyResponse';
import { elevioActions } from '../elevio.actions';

type SmartReplyResponseState = {
  loading: boolean;
  data: Pick<SmartReplyResponsePayloadV2, 'response'> | null;
  tabStatus: 'reply' | 'note';
};

const initialSmartReplyResponseState: SmartReplyResponseState = {
  loading: false,
  data: null,
  tabStatus: 'reply',
};

export const smartReplyReducer = createReducer(
  initialSmartReplyResponseState,
  (builder) => {
    builder.addCase(elevioActions.smartReply.smartReplyRequested, (state) => {
      state.loading = true;
      state.data = null;
    });
    builder.addCase(
      elevioActions.smartReply.smartReplyResponseReceived,
      (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      },
    );
    builder.addCase(
      elevioActions.smartReply.smartReplyResponseError,
      (state) => {
        state.loading = false;
      },
    );
    builder.addCase(elevioActions.smartReply.smartReplyFinally, (state) => {
      state.loading = false;
    });
    builder.addCase(
      elevioActions.smartReply.updateReplySectionTabStatus,
      (state, action) => {
        state.tabStatus = action.payload.tabStatus;
      },
    );
  },
);
